export default __webpack_public_path__ + "static/media/Yourpersonality.b4d148de.m4v";